// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.SO0bkbDgUlnZm1wbYp6A {
  background: #fff;
  border: 1px solid var(--curio-border);
  border-radius: var(--curio-radius-lg);
  box-shadow: var(--curio-shadow-card);
  overflow: hidden;
}

.dQrGRLObprtd93IDwyBd {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  padding: 10px 14px;
  border-bottom: 1px solid var(--curio-border);
}

.U3eExhpG2yMrrcnuFOMo {
  font: inherit;
  font-size: 12px;
  cursor: pointer;
  border: 1px solid var(--curio-border-strong);
  background: var(--curio-surface-muted);
  color: var(--curio-text-primary);
  border-radius: var(--curio-radius-pill);
  padding: 3px 10px;
}

.vKAab_BEhA_C39RQUaIt {
  opacity: 0.45;
  text-decoration: line-through;
}

.RCnZrxR36rjcCEFM7nIX {
  margin-left: auto;
  font-size: 12px;
  color: var(--curio-warning-text);
}

.qGywPldaDzOkRl4OHs8g {
  margin: 0;
  padding: 22px 16px;
  font-size: 13px;
  color: var(--curio-text-secondary);
}

.pAAB1dv2qSPeXBr4awbE {
  list-style: none;
  margin: 0;
  padding: 0;
  /* The log is the one unbounded region on the page, so it owns its scroll
     rather than stretching the shell. */
  max-height: 360px;
  overflow-y: auto;
}

.wjLt_aoCyrIwfE2vWPHd {
  border-bottom: 1px solid var(--curio-border);
}

.wjLt_aoCyrIwfE2vWPHd:last-child {
  border-bottom: none;
}

.my8JclKlOZavwRNS6cBw {
  width: 100%;
  display: flex;
  align-items: baseline;
  gap: 10px;
  text-align: left;
  font: inherit;
  cursor: pointer;
  background: none;
  border: none;
  padding: 8px 14px;
}

.my8JclKlOZavwRNS6cBw:hover {
  background: var(--curio-surface-muted);
}

.TTyuHPhxAr_lYDjGjz62 {
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11px;
  color: var(--curio-text-muted);
  white-space: nowrap;
}

.sj3OIP2b8YUudEOrjldF {
  font-size: 11px;
  font-weight: 600;
  padding: 1px 7px;
  border-radius: var(--curio-radius-pill);
  white-space: nowrap;
}

.c25Y35vLhrsDRe7UD78K {
  background: var(--curio-danger-bg);
  color: var(--curio-danger-text);
}

.bpn0CgFRYSjMww2cKBvW {
  background: var(--curio-warning-bg);
  color: var(--curio-warning-text);
}

.spdGNBU6EYdLyCaLie_q {
  background: var(--curio-surface-muted);
  color: var(--curio-text-secondary);
}

.As40Ol1ebWaK5je7hTmN {
  background: var(--curio-surface-alt);
  color: var(--curio-text-secondary);
}

.seeIFshIy3chaRfQNSOr {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  color: var(--curio-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.h_yXlFIwf0rMA_KTEaP4 {
  font-size: 11px;
  font-weight: 600;
  color: var(--curio-text-secondary);
  background: var(--curio-surface-muted);
  border-radius: var(--curio-radius-pill);
  padding: 1px 7px;
}

.sBg827QnRkg9liwiC6p8 {
  margin: 0;
  padding: 10px 14px 14px;
  background: var(--curio-surface-alt);
  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;
  font-size: 11.5px;
  line-height: 1.45;
  color: var(--curio-text-primary);
  /* pre-wrap, not nowrap: a traceback with a long path must wrap rather than
     push a horizontal scrollbar under every row. */
  white-space: pre-wrap;
  word-break: break-word;
  max-height: 260px;
  overflow-y: auto;
}
`, "",{"version":3,"sources":["webpack://./src/pages/monitor/ErrorLogPanel.module.css"],"names":[],"mappings":"AAAA;EACE,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,mBAAmB;EACnB,QAAQ;EACR,kBAAkB;EAClB,4CAA4C;AAC9C;;AAEA;EACE,aAAa;EACb,eAAe;EACf,eAAe;EACf,4CAA4C;EAC5C,sCAAsC;EACtC,gCAAgC;EAChC,uCAAuC;EACvC,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,kCAAkC;AACpC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV;wCACsC;EACtC,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,SAAS;EACT,gBAAgB;EAChB,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,2DAA2D;EAC3D,eAAe;EACf,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;EACE,mCAAmC;EACnC,gCAAgC;AAClC;;AAEA;EACE,sCAAsC;EACtC,kCAAkC;AACpC;;AAEA;EACE,oCAAoC;EACpC,kCAAkC;AACpC;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,eAAe;EACf,gCAAgC;EAChC,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,kCAAkC;EAClC,sCAAsC;EACtC,uCAAuC;EACvC,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,uBAAuB;EACvB,oCAAoC;EACpC,2DAA2D;EAC3D,iBAAiB;EACjB,iBAAiB;EACjB,gCAAgC;EAChC;mDACiD;EACjD,qBAAqB;EACrB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".panel {\n  background: #fff;\n  border: 1px solid var(--curio-border);\n  border-radius: var(--curio-radius-lg);\n  box-shadow: var(--curio-shadow-card);\n  overflow: hidden;\n}\n\n.filters {\n  display: flex;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 8px;\n  padding: 10px 14px;\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.filter {\n  font: inherit;\n  font-size: 12px;\n  cursor: pointer;\n  border: 1px solid var(--curio-border-strong);\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-primary);\n  border-radius: var(--curio-radius-pill);\n  padding: 3px 10px;\n}\n\n.filterOff {\n  opacity: 0.45;\n  text-decoration: line-through;\n}\n\n.dropped {\n  margin-left: auto;\n  font-size: 12px;\n  color: var(--curio-warning-text);\n}\n\n.empty {\n  margin: 0;\n  padding: 22px 16px;\n  font-size: 13px;\n  color: var(--curio-text-secondary);\n}\n\n.list {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  /* The log is the one unbounded region on the page, so it owns its scroll\n     rather than stretching the shell. */\n  max-height: 360px;\n  overflow-y: auto;\n}\n\n.row {\n  border-bottom: 1px solid var(--curio-border);\n}\n\n.row:last-child {\n  border-bottom: none;\n}\n\n.rowHead {\n  width: 100%;\n  display: flex;\n  align-items: baseline;\n  gap: 10px;\n  text-align: left;\n  font: inherit;\n  cursor: pointer;\n  background: none;\n  border: none;\n  padding: 8px 14px;\n}\n\n.rowHead:hover {\n  background: var(--curio-surface-muted);\n}\n\n.time {\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11px;\n  color: var(--curio-text-muted);\n  white-space: nowrap;\n}\n\n.source {\n  font-size: 11px;\n  font-weight: 600;\n  padding: 1px 7px;\n  border-radius: var(--curio-radius-pill);\n  white-space: nowrap;\n}\n\n.sourceNode {\n  background: var(--curio-danger-bg);\n  color: var(--curio-danger-text);\n}\n\n.sourceSandbox {\n  background: var(--curio-warning-bg);\n  color: var(--curio-warning-text);\n}\n\n.sourceBackend {\n  background: var(--curio-surface-muted);\n  color: var(--curio-text-secondary);\n}\n\n.sourceClient {\n  background: var(--curio-surface-alt);\n  color: var(--curio-text-secondary);\n}\n\n.summary {\n  flex: 1;\n  min-width: 0;\n  font-size: 13px;\n  color: var(--curio-text-primary);\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.count {\n  font-size: 11px;\n  font-weight: 600;\n  color: var(--curio-text-secondary);\n  background: var(--curio-surface-muted);\n  border-radius: var(--curio-radius-pill);\n  padding: 1px 7px;\n}\n\n.detail {\n  margin: 0;\n  padding: 10px 14px 14px;\n  background: var(--curio-surface-alt);\n  font-family: ui-monospace, SFMono-Regular, Menlo, monospace;\n  font-size: 11.5px;\n  line-height: 1.45;\n  color: var(--curio-text-primary);\n  /* pre-wrap, not nowrap: a traceback with a long path must wrap rather than\n     push a horizontal scrollbar under every row. */\n  white-space: pre-wrap;\n  word-break: break-word;\n  max-height: 260px;\n  overflow-y: auto;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"panel": `SO0bkbDgUlnZm1wbYp6A`,
	"filters": `dQrGRLObprtd93IDwyBd`,
	"filter": `U3eExhpG2yMrrcnuFOMo`,
	"filterOff": `vKAab_BEhA_C39RQUaIt`,
	"dropped": `RCnZrxR36rjcCEFM7nIX`,
	"empty": `qGywPldaDzOkRl4OHs8g`,
	"list": `pAAB1dv2qSPeXBr4awbE`,
	"row": `wjLt_aoCyrIwfE2vWPHd`,
	"rowHead": `my8JclKlOZavwRNS6cBw`,
	"time": `TTyuHPhxAr_lYDjGjz62`,
	"source": `sj3OIP2b8YUudEOrjldF`,
	"sourceNode": `c25Y35vLhrsDRe7UD78K`,
	"sourceSandbox": `bpn0CgFRYSjMww2cKBvW`,
	"sourceBackend": `spdGNBU6EYdLyCaLie_q`,
	"sourceClient": `As40Ol1ebWaK5je7hTmN`,
	"summary": `seeIFshIy3chaRfQNSOr`,
	"count": `h_yXlFIwf0rMA_KTEaP4`,
	"detail": `sBg827QnRkg9liwiC6p8`
};
export default ___CSS_LOADER_EXPORT___;
